import { useMemo } from 'react';

import { useElementWidth } from '../../../../hooks/useElementWidth';
import {
  actionsWidth,
  setsColumnWidth,
  sideColumnWidth,
  typeColumnWidth,
} from '../../../../shared/constants';
import { getColumnWidth } from '../../../../utils/ui/column-size-utils';

export function useSetTableCalculation({
  optionColumnsCount,
  splitBySide,
  hideSetsCount,
  showSetItemStatus,
}: {
  optionColumnsCount: number;
  splitBySide: boolean;
  hideSetsCount: boolean;
  showSetItemStatus?: boolean;
}) {
  const { ref, width } = useElementWidth();

  const columnWidth = useMemo(
    () =>
      getColumnWidth(
        width,
        optionColumnsCount + 1, // rest column
        typeColumnWidth +
          (hideSetsCount ? 0 : setsColumnWidth) +
          (splitBySide ? sideColumnWidth : 0) +
          (showSetItemStatus ? actionsWidth : 0) +
          actionsWidth,
      ),
    [width, optionColumnsCount, hideSetsCount, splitBySide, showSetItemStatus],
  );

  return {
    ref,
    columnWidth,
  };
}
